/* Tonality navigation and external-link behaviour. */
(() => {
  const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
  function prepareLinks(root) {
    const links = root.matches?.('a[href]') ? [root] : [];
    links.push(...root.querySelectorAll('a[href]'));
    links.forEach((link) => {
      if (!['http:', 'https:'].includes(link.protocol) || link.hostname === location.hostname) return;
      link.target = '_blank';
      link.relList.add('noopener', 'noreferrer');
    });
  }
  function prepareMenus(root) {
    root.querySelectorAll('.header__inline-menu details').forEach((details) => {
      if (details.dataset.tonalityMenuReady) return;
      details.dataset.tonalityMenuReady = 'true';
      const summary = details.querySelector(':scope > summary');
      const sync = () => summary?.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', sync);
      details.addEventListener('mouseenter', () => {
        if (hoverCapable.matches) { details.open = true; sync(); }
      });
      details.addEventListener('mouseleave', () => {
        if (hoverCapable.matches && !details.contains(document.activeElement)) {
          details.open = false; sync();
        }
      });
      details.addEventListener('focusout', () => requestAnimationFrame(() => {
        if (!details.contains(document.activeElement) && !details.matches(':hover')) {
          details.open = false; sync();
        }
      }));
      summary?.querySelectorAll('.tonality-menu-link').forEach((link) => {
        link.addEventListener('click', (event) => event.stopPropagation());
      });
      sync();
    });
  }
  prepareLinks(document);
  prepareMenus(document);
  document.addEventListener('shopify:section:load', (event) => prepareMenus(event.target));
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) prepareLinks(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
})();
